import img1 from "../src/img/Ambur-Biryani-2-3.jpg";
import img2 from "../src/img/hyd.webp";
import img3 from "../src/img/arabic.jpg";
import img4 from "../src/img/chettai.jpg";
import img5 from "../src/img/Mandi-House.jpg";
const Briyanidata ={
    cardData : [
  
             {
                id: 1,
                imgSrc:img1 ,
                title: 'Ambur Briyani',
                cont : 'Ambur Briyani , Hyderabadi Briyani , Arbian Briyani , Chattinadu Briyani,Mandi Briyani',
                 link : './Briyani',
                 rs : '140'
             },
             {
                 id: 2,
                 imgSrc:img2 ,
                 title: 'Hyderabadi Briyani',
                 cont : 'Ambur Briyani , Hyderabadi Briyani , Arbian Briyani , Chattinadu Briyani,Mandi Briyani',
                 rs : '240'
              } ,
              {
                 id: 3,
                 imgSrc:img3 ,
                 title: ' Arabian Briyani',
                 cont : 'Ambur Briyani , Hyderabadi Briyani , Arbian Briyani , Chattinadu Briyani,Mandi Briyani',
                 rs : '280'
               } ,
              {
                 id: 4,
                 imgSrc:img4,
                 title: 'Chettinadu Briyani',
                 cont : 'Ambur Briyani , Hyderabadi Briyani , Arbian Briyani , Chattinadu Briyani,Mandi Briyani',
                 rs : '160'
              },
              {
                id: 5,
                imgSrc:img5 ,
                title: 'Mandi Briyani',  
                cont : 'Ambur Briyani , Hyderabadi Briyani , Arbian Briyani , Chattinadu Briyani',
                rs : '270'
             }
     ]
 };
 
 export default Briyanidata;